import { forwardRef, type Ref, type SVGProps } from "react";
const IconLinkBrokenOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20.1 16.32a5.49 5.49 0 0 1-4.42-2.21 1 1 0 1 1 1.6-1.19 3.53 3.53 0 0 0 4.93.7l4.38-3.29a3.52 3.52 0 0 0 .71-4.92 3.54 3.54 0 0 0-4.93-.71L19 7.46a1 1 0 1 1-1.28-1.54l3.38-2.79a5.51 5.51 0 0 1 8.8 5.17 5.42 5.42 0 0 1-2.15 3.63l-4.38 3.29a5.53 5.53 0 0 1-3.27 1.1M7.85 30a5.52 5.52 0 0 1-4.49-8.71l2.7-3.46a1 1 0 0 1 1.58 1.24L5 22.48A3.52 3.52 0 0 0 8.44 28a3.47 3.47 0 0 0 2.28-1.43l3.18-4.47a3.52 3.52 0 0 0-.83-4.9 1 1 0 1 1 1.16-1.63 5.52 5.52 0 0 1 1.3 7.69l-3.18 4.47A5.5 5.5 0 0 1 7.85 30M12 13a1 1 0 0 1-.71-.29L7.78 9.2A1 1 0 0 1 9.2 7.78l3.49 3.49a1 1 0 0 1 0 1.42A1 1 0 0 1 12 13m-2.23 3a1 1 0 0 1-.26 0l-4.77-1.31a1 1 0 1 1 .52-1.93L10 14a1 1 0 0 1 .7 1.23 1 1 0 0 1-.93.77M15 10.77a1 1 0 0 1-1-.77l-1.24-4.74a1 1 0 1 1 1.93-.52L16 9.51a1 1 0 0 1-.71 1.22.8.8 0 0 1-.29.04" />
  </svg>
);
const ForwardRef = forwardRef(IconLinkBrokenOutlineSVG);
ForwardRef.displayName = "IconLinkBrokenOutline";
export { ForwardRef as IconLinkBrokenOutline };
